import { Control } from '@yleisradio/areena-types';
import React from 'react';
import styles from './HeroControls.module.scss';
import { Controls } from 'components/Controls';

type Props = {
  controls: Control[];
};

export const HeroControls: React.FunctionComponent<Props> = ({ controls }) => {
  return (
    <>
      <div className={styles.mobile}>
        <Controls controls={controls} as="button" size="xs" />
      </div>
      <div className={styles.desktop}>
        <Controls controls={controls} as="button" size="sm" />
      </div>
    </>
  );
};
